import { render, staticRenderFns } from "./BlockEditCreate.vue?vue&type=template&id=42420bfc&scoped=true"
import script from "./BlockEditCreate.vue?vue&type=script&lang=js"
export * from "./BlockEditCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42420bfc",
  null
  
)

export default component.exports